import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CardList, CardListAction } from '../../../../common/components/cards';
import { useQuery } from '../../../../common/utils/useQuery';
import { GroupVisitDto } from '../../groupVisits.dtos';
import { Checkbox, SearchField } from '../../../../common/components/fields';
import GroupVisitListItem from './groupVisitListItem';
import { rootSelector } from '../../../../common/selectors/selectors';
import { getType } from 'typesafe-actions';
import { groupVisitsActions } from '../../groupVisits.actions';

const GroupVisitsList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const query = useQuery();

  const systemGroupVisits = rootSelector((state) => state.groupVisits.list);

  const [showInactive, setShowInactive] = useState<boolean>(false);
  const [groupVisits, setGroupVisits] = useState<GroupVisitDto[]>([]);

  const searchQuery = query.get('search');

  useEffect(() => {
    dispatch({ type: getType(groupVisitsActions.request) });
  }, [dispatch]);

  useEffect(() => {
    setGroupVisits(systemGroupVisits);
  }, [systemGroupVisits]);

  const onAdd = () => {
    history.push('/group-visits/create');
  };

  const onSearch = (searchQuery: string) => {
    const query = searchQuery.toLowerCase();
    const filteredExhibits = systemGroupVisits.filter(
      (s) =>
        s.groupName.toLowerCase().includes(query) ||
        s.contact.toLowerCase().includes(query) ||
        s.email.toLowerCase().includes(query) ||
        s.phone.includes(query)
    );
    setGroupVisits(filteredExhibits);
  };

  return (
    <CardList
      actions={[
        <CardListAction
          key='Add new group visit'
          onClick={onAdd}
          tooltip='Add new group visit'
        />,
      ]}
      cards={groupVisits
        .filter((g) => showInactive || g.isActive === true)
        .map((g, i) => (
          <GroupVisitListItem key={i} groupVisit={g} />
        ))}
      filters={[
        <SearchField
          key='SearchField'
          onSearch={onSearch}
          options={[]}
          value={searchQuery!}
        />,
        <Checkbox
          key='Switch'
          color='primary'
          label='Include Inactive'
          onChange={() => setShowInactive(!showInactive)}
          checked={showInactive}
          value={showInactive}
        />,
      ]}
      onScroll={() => console.log('You scrolled')}
      title='Group Visits'
    />
  );
};

export default GroupVisitsList;
